import { Outlet } from 'react-router';
import { ToastProvider } from '../contexts/ToastContext';
import { ThemeProvider } from '../../contexts/ThemeContext';

export function RootLayout() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <Outlet />
      </ToastProvider>
    </ThemeProvider>
  );
}